module.exports = __webpack_public_path__ + "static/media/menu-boczne-moje-dane_BLUE.7c299515.svg";